import styled from 'styled-components';

export const HeroContainer = styled.section`
  padding: 76px 24px 88px; background: var(--background);
  @media (max-width: 768px) { padding: 40px 20px 64px; }
`;
export const HeroInnerContainer = styled.div`
  width: min(1180px, 100%); margin: 0 auto;
  display: grid; grid-template-columns: minmax(0, 1.35fr) minmax(0, 0.9fr);
  align-items: center; gap: 72px;
  @media (max-width: 900px) { grid-template-columns: 1fr; gap: 40px; }
`;
export const HeroLeftContainer = styled.div`
  grid-column: 2; grid-row: 1; min-width: 0;
  @media (max-width: 900px) { grid-column: 1; grid-row: 2; width: min(480px, 100%); }
`;
export const HeroRightContainer = styled.div`
  grid-column: 1; grid-row: 1; min-width: 0;
`;
export const HeroFrame = styled.figure`
  position: relative; padding: 0; margin: 0;
  overflow: hidden; border-radius: 24px; background: var(--surface);
  border: 1px solid var(--border); box-shadow: var(--shadow-card);
`;
export const Img = styled.img`
  display: block; width: 100%; height: auto; aspect-ratio: 4 / 5;
  object-fit: cover; object-position: 60% 45%;
`;
export const AvailabilityBadge = styled.div`
  position: absolute; top: 20px; left: 20px; z-index: 1;
  display: inline-flex; align-items: center; gap: 8px;
  padding: 9px 13px; border-radius: 999px; background: var(--surface);
  color: var(--green); font-size: 12px; font-weight: 650;
  span { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }
`;
export const InfoCard = styled.figcaption`
  display: flex; align-items: center; gap: 12px; padding: 18px 22px;
  color: var(--text); font-size: 13px; line-height: 1.5;
  strong { font-weight: 500; } svg { flex-shrink: 0; color: var(--accent); }
`;
export const HeroCopy = styled.div`width: 100%;`;
export const HeroKicker = styled.div`
  display: flex; align-items: center; gap: 10px;
  color: var(--accent); font-size: 13px; line-height: 1.7; font-weight: 600;
  span { flex-shrink: 0; width: 22px; height: 1px; background: currentColor; }
`;
export const Title = styled.h1`
  margin: 24px 0; color: var(--text);
  font-family: 'Newsreader', Georgia, serif;
  font-size: clamp(56px, 6.7vw, 88px); line-height: 0.98;
  font-weight: 600; letter-spacing: -0.045em;
  @media (max-width: 560px) { font-size: clamp(43px, 11.5vw, 64px); }
`;
export const TitleAccent = styled.span`display: block; color: var(--accent);`;
export const SubTitle = styled.p`
  max-width: 600px; color: var(--muted); font-size: 18px; line-height: 1.75;
  @media (max-width: 560px) { font-size: 16px; }
`;
export const ButtonContainer = styled.div`
  display: flex; flex-wrap: wrap; gap: 12px; margin-top: 30px;
  @media (max-width: 560px) { flex-direction: column; }
`;
export const ResumeButton = styled.a`
  min-height: 48px; display: inline-flex; align-items: center; justify-content: center;
  gap: 10px; padding: 12px 18px; border-radius: 8px;
  background: var(--button-bg); color: var(--button-text);
  border: 1px solid var(--button-bg); text-decoration: none; font-size: 14px; font-weight: 600;
  transition: transform 180ms ease, box-shadow 180ms ease;
  &:hover { transform: translateY(-2px); box-shadow: var(--shadow-card); }
`;
export const ExploreButton = styled.button`
  min-height: 48px; display: inline-flex; align-items: center; justify-content: center;
  gap: 10px; padding: 12px 18px; border-radius: 8px;
  background: transparent; color: var(--text); border: 1px solid var(--border);
  font-size: 14px; font-weight: 600; cursor: pointer;
  transition: border-color 180ms ease, transform 180ms ease;
  &:hover { border-color: var(--accent); transform: translateY(-2px); }
`;
export const ContactButton = styled(ExploreButton).attrs({ as: 'a' })`text-decoration: none;`;
export const SocialBar = styled.div`display: flex; gap: 12px; flex-wrap: wrap; margin-top: 26px;`;
export const SocialLink = styled.a`
  width: 44px; height: 44px; display: inline-flex; align-items: center; justify-content: center;
  color: var(--muted); border: 1px solid var(--border); border-radius: 50%;
  transition: color 180ms ease, border-color 180ms ease;
  &:hover { color: var(--accent); border-color: var(--accent); }
`;
